import { OrganizationLanguage } from '@/features/settings/api/types/gdpr';

export const getTranslationBasedOnLanguage = (
  translations: Record<OrganizationLanguage, string>,
  language: OrganizationLanguage,
) => {
  switch (true) {
    case translations?.[language]?.length > 0:
      return translations?.[language];
    case translations?.en?.length > 0:
      return translations.en;
    case translations?.pl?.length > 0:
      return translations.pl;
    default:
      return 'N/A';
  }
};
